import React from "react";
import Brand from "../../Brand";
import { OnboardingFormProps } from "../Types";

const BrandStep: React.FC<OnboardingFormProps> = () => (
  <div style={{ width: "100%", maxWidth: "800px", textAlign: "left" }}>
    <h1>🎨 Brand</h1>
    <Brand />
  </div>
);

export default BrandStep;
